import Vue from 'vue';
import * as Sentry from '@sentry/vue';

export default async (ctx) => {
  const sentryURL = ctx.$config.sentryUrl;
  const environment = ctx.$config.ocusEnvironment;

  const { Replay } = await import('@sentry/replay');

  Sentry.init({
    Vue,
    dsn: sentryURL,
    environment,
    integrations: [
      new Replay({
        sessionSampleRate: 0.1,
        errorSampleRate: 1.0,
      }),
    ],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
    ignoreErrors: [
      /Error: Request failed with status code /i,
      /Network Error /i,
      /SyntaxError: Failed to execute /i,
      /Cannot read properties of undefined /i,
    ],
  });
};
